import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-860998ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Horcrux ", -1))
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Horcrux generated from ")
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  class: "title",
  ref: "title",
  type: "text",
  placeholder: "Your printed title"
}
const _hoisted_9 = { class: "print" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Hexadecimal", -1))
const _hoisted_11 = { class: "secret" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qr = _resolveComponent("qr")!

  return (!!_ctx.value.share)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h3", null, [
          _createTextVNode(_toDisplayString(_ctx.date) + " / ", 1),
          _createElementVNode("span", _hoisted_3, "v" + _toDisplayString(_ctx.value?.version), 1)
        ]),
        _createElementVNode("p", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("a", { href: _ctx.location }, _toDisplayString(_ctx.location), 9, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("input", _hoisted_8, null, 512),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.value?.share), 1),
          _createVNode(_component_qr, {
            class: "qrcode",
            message: _ctx.value.share
          }, null, 8, ["message"]),
          _hoisted_12
        ])
      ]))
    : _createCommentVNode("", true)
}